module.exports = __webpack_public_path__ + "static/2gde-afb9078c1346c72b9d4375409c00059d.gif";